(() => {
  /* Add to cart: the product image flies into the header cart icon (GSAP, loaded on demand by the theme's runtime). */
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let gsapPromise = null;
  const getGsap = () => {
    if (window.gsap && window.BezelorGSAP && window.BezelorGSAP.load) return window.BezelorGSAP.load([]);
    if (gsapPromise) return gsapPromise;
    gsapPromise = new Promise((resolve, reject) => {
      let tries = 0;
      const timer = setInterval(() => {
        if (window.BezelorGSAP && window.BezelorGSAP.load) { clearInterval(timer); window.BezelorGSAP.load([]).then(resolve, reject); }
        else if (++tries > 80) { clearInterval(timer); gsapPromise = null; reject(new Error('gsap unavailable')); }
      }, 100);
    });
    return gsapPromise;
  };
  /* Warm up once the page is idle so the first click is instant */
  const warm = () => getGsap().catch(() => {});
  if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 3000 }); else setTimeout(warm, 2000);

  const cartIcon = () => document.getElementById('cart-icon-bubble');
  const mainImage = () => {
    const list = [...document.querySelectorAll('product-info media-gallery img')].filter((img) => {
      const r = img.getBoundingClientRect();
      return r.width > 140 && r.height > 140 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
    });
    list.sort((a, b) => (b.getBoundingClientRect().width * b.getBoundingClientRect().height) - (a.getBoundingClientRect().width * a.getBoundingClientRect().height));
    return list[0] || null;
  };

  const fly = (gsap, button) => {
    const icon = cartIcon();
    const btnBox = button.getBoundingClientRect();
    const img = mainImage();
    const og = document.querySelector('meta[property="og:image"]');
    const src = (img && (img.currentSrc || img.src)) || (og && og.content) || '';
    const startBox = img ? img.getBoundingClientRect() : btnBox;
    const sx = startBox.left + startBox.width / 2;
    const sy = startBox.top + startBox.height / 2;
    let ex = window.innerWidth - 40;
    let ey = 36;
    if (icon) {
      const r = icon.getBoundingClientRect();
      if (r.width && r.bottom > 0 && r.top < window.innerHeight) { ex = r.left + r.width / 2; ey = r.top + r.height / 2; }
    }
    const bump = () => {
      if (!icon) return;
      gsap.fromTo(icon, { scale: 1 }, { scale: 1.3, duration: 0.16, yoyo: true, repeat: 1, ease: 'power2.out', clearProps: 'transform' });
      const bubble = icon.querySelector('.cart-count-bubble');
      if (bubble) gsap.fromTo(bubble, { scale: 0.6 }, { scale: 1, duration: 0.5, ease: 'back.out(3)', delay: 0.15, clearProps: 'transform' });
    };
    const label = button.querySelector('span');
    if (label) gsap.fromTo(label, { scale: 0.93 }, { scale: 1, duration: 0.45, ease: 'back.out(3)', clearProps: 'transform' });
    if (reduced() || !src) { bump(); return; }

    const size = 112;
    const el = document.createElement('div');
    el.className = 'bzpdp-fly';
    el.setAttribute('aria-hidden', 'true');
    /* Inline styles on purpose: the theme already has a .bz-fly class that is hidden */
    el.style.cssText = 'position:fixed;left:0;top:0;z-index:2147483000;display:block;width:' + size + 'px;height:' + size + 'px;border-radius:50%;background-color:#fff;background-size:cover;background-position:center;pointer-events:none;will-change:transform,opacity;box-shadow:0 0 0 3px #f3dc95,0 18px 34px -10px rgba(0,0,0,.55);';
    el.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")';
    document.body.appendChild(el);
    gsap.set(el, { x: sx - size / 2, y: sy - size / 2, scale: 0.55, opacity: 0, transformOrigin: '50% 50%' });
    const tl = gsap.timeline({ onComplete: () => { el.remove(); bump(); } });
    tl.to(el, { opacity: 1, scale: 1, duration: 0.2, ease: 'back.out(2)' });
    tl.to(el, { x: ex - size / 2, duration: 0.85, ease: 'power1.inOut' }, 'fly');
    tl.to(el, { y: ey - size / 2, duration: 0.85, ease: 'power3.in' }, 'fly');
    tl.to(el, { scale: 0.2, rotation: 200, duration: 0.85, ease: 'power2.in' }, 'fly');
    tl.to(el, { opacity: 0, duration: 0.14 }, '-=0.14');
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('.bz-buybox .product-form__submit');
    if (button) {
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      getGsap().then((gsap) => fly(gsap, button)).catch(() => {});
      return;
    }
    const step = event.target.closest && event.target.closest('.bz-buybox .quantity__button');
    if (step && !step.classList.contains('disabled')) {
      const input = step.parentElement.querySelector('.quantity__input');
      if (input) getGsap().then((gsap) => gsap.fromTo(input, { scale: 1.45 }, { scale: 1, duration: 0.4, ease: 'back.out(3)', clearProps: 'transform' })).catch(() => {});
    }
  }, true);
})();
